import Axios from 'axios';
var EntrustDeliverService = (function () {
    function EntrustDeliverService() {
    }
    EntrustDeliverService.prototype.getList = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/list', { params: params });
    };
    EntrustDeliverService.prototype.getDetail = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/detail', { params: params });
    };
    EntrustDeliverService.prototype.getListGoods = function (params) {
        return Axios.post('supplierclientapi/entrust_delivery_order/list_goods', params);
    };
    EntrustDeliverService.prototype.addDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/entrust_delivery_order/create', params);
    };
    EntrustDeliverService.prototype.updateDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/entrust_delivery_order/update', params);
    };
    EntrustDeliverService.prototype.getGoodsList = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/goods_list', { params: params });
    };
    EntrustDeliverService.prototype.getEditOrderInfo = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/update_info', { params: params });
    };
    EntrustDeliverService.prototype.setAudit = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/audit', { params: params });
    };
    EntrustDeliverService.prototype.setCancel = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/cancel', { params: params });
    };
    EntrustDeliverService.prototype.getBusinessGoodsList = function (params) {
        return Axios.get('supplierclientapi/businessgoodsprice/goods_list', { params: params });
    };
    EntrustDeliverService.prototype.documentManualSync = function (params) {
        return Axios.post('supplierclientapi/entrust_delivery_order/sync_document', params);
    };
    EntrustDeliverService.prototype.getGoodAlreadyBindLicenses = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/document_list', { params: params });
    };
    EntrustDeliverService.prototype.getDeliveryOrderPrintDetail = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/print_detail', { params: params });
    };
    EntrustDeliverService.prototype.getRefundDeliveryList = function (params) {
        return Axios.get('supplierclientapi/entrust_delivery_order/refund_delivery_list', { params: params });
    };
    EntrustDeliverService.prototype.getRefundDeliveryDetail = function (params) {
        return Axios.get('/supplierclientapi/entrust_delivery_order/refund_delivery_detail', { params: params });
    };
    EntrustDeliverService.prototype.getDeliveryOrderGoods = function (params) {
        return Axios.get('/supplierclientapi/entrust_delivery_order/goods', { params: params });
    };
    EntrustDeliverService.prototype.batchUpdateDeliveryInfo = function (params) {
        return Axios.post('/supplierclientapi/deliveryorder/batch_update_info', params);
    };
    EntrustDeliverService.prototype.batchUpdateEntrustInfo = function (params) {
        return Axios.post('/supplierclientapi/entrust_delivery_order/batch_update_info', params);
    };
    EntrustDeliverService.prototype.splitEntrustedDeliveryOrder = function (params) {
        return Axios.post('supplierclientapi/entrust_delivery_order/split', params);
    };
    EntrustDeliverService.createInstance = function () {
        EntrustDeliverService.getInstance();
    };
    EntrustDeliverService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return EntrustDeliverService;
}());
export default EntrustDeliverService;
